import React, { Component } from "react";
// import { Link } from "react-router-dom";
import styled from "styled-components";

import PowerSystem from "../../commons/components/Ems/PowerSystem";
import SystemInfo from "../../commons/components/Ems/SystemInfo";
import PowerPlantInfo from "../../commons/components/Ems/PowerPlantInfo";
import EnergyStatus from "../../commons/components/Ems/EnergyStatus";

class EmsMain extends Component {
  // constructor(props) {}

  render() {
    return (
      <EmsContainer>
        <GridContainer girdFr={"4.3fr 1fr"}>
          <PowerSystem />
          <SystemInfo />
        </GridContainer>
        <GridContainer girdFr={"1fr 1fr 3fr"}>
          <PowerPlantInfo />
        </GridContainer>
        <EnergyStatus />
      </EmsContainer>
    );
  }
}
const EmsContainer = styled.div`
  background-color: #333;
  min-height: 100vh;
  padding: 20px;
`;
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: ${({ girdFr }) => girdFr || "1fr 1fr 1fr"};
  gap: 15px;
  margin-bottom: 20px;
`;
export const GridContent = styled.div``;
export const InnerContent = styled.div`
  background-color: #fff;
  border-radius: 6px;
  padding: 20px;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  color: #fff;
  margin-bottom: 10px;
`;
export default EmsMain;
